import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../data/notification";
import useT from "../../i18n/useT";

const CalculatorCategories = () => {
    const t = useT();
    const dispatch = useDispatch();
    const role = useSelector((state) => state.user.role);
    const isStaff = role === "admin" || role === "moderator";
    const isAdmin = role === "admin";

    const [rows, setRows] = useState([]);
    const [updates, setUpdates] = useState(0);
    const [adding, setAdding] = useState({ code: "", label: "", land_markup: "", container_markup: "" });

    const notify = (text, type) => {
        dispatch(notificationActions.changeNotification({ show: true, text, type }));
        setTimeout(() => dispatch(notificationActions.changeNotification({ show: false, text: "", type: "" })), 4000);
    };

    useEffect(() => {
        if (!isStaff) return;
        axios.get("/api/calculator-categories").then((res) => setRows(res.data.data || [])).catch(() => {});
    }, [isStaff, updates]);

    if (!isStaff) {
        return <div className="page-content-main-container"><h2 className="page-title">{t("calccat.title")}</h2></div>;
    }

    const setField = (id, patch) => setRows((prev) => prev.map((r) => (r.id === id ? { ...r, ...patch } : r)));

    const save = (r) => {
        axios.put(`/api/calculator-categories/${r.id}`, { label: r.label, land_markup: r.land_markup, container_markup: r.container_markup })
            .then((res) => { notify(res.data.message.en, "success-notification"); setUpdates((u) => u + 1); })
            .catch((err) => notify(err.response?.data?.message?.en || "Error", "error-notification"));
    };
    const add = () => {
        if (!adding.code.trim()) return;
        axios.post("/api/calculator-categories", adding)
            .then((res) => { notify(res.data.message.en, "success-notification"); setAdding({ code: "", label: "", land_markup: "", container_markup: "" }); setUpdates((u) => u + 1); })
            .catch((err) => notify(err.response?.data?.message?.en || "Error", "error-notification"));
    };
    const remove = (id) => {
        if (!window.confirm(t("calccat.confirmDelete"))) return;
        axios.delete(`/api/calculator-categories/${id}`)
            .then((res) => { notify(res.data.message.en, "success-notification"); setUpdates((u) => u + 1); })
            .catch((err) => notify(err.response?.data?.message?.en || "Error", "error-notification"));
    };

    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("calccat.title")}</h2>
            <div style={{ fontSize: "13px", opacity: 0.7, marginBottom: "16px" }}>{t("calccat.hint")}</div>

            <div style={{ overflowX: "auto" }}>
                <table className="table" style={{ width: "100%", maxWidth: "760px" }}>
                    <thead>
                        <tr>
                            <th>{t("calccat.code")}</th>
                            <th>{t("calccat.label")}</th>
                            <th>{t("calccat.landMarkup")}</th>
                            <th>{t("calccat.containerMarkup")}</th>
                            {isAdmin && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.id}>
                                <td><strong>{r.code}</strong></td>
                                <td><input className="form-control" style={{ minWidth: "120px" }} value={r.label || ""} disabled={!isAdmin} onChange={(e) => setField(r.id, { label: e.target.value })} /></td>
                                <td><input type="number" step="0.01" className="form-control" style={{ width: "110px" }} value={r.land_markup} disabled={!isAdmin} onChange={(e) => setField(r.id, { land_markup: e.target.value })} /></td>
                                <td><input type="number" step="0.01" className="form-control" style={{ width: "110px" }} value={r.container_markup} disabled={!isAdmin} onChange={(e) => setField(r.id, { container_markup: e.target.value })} /></td>
                                {isAdmin && (
                                    <td style={{ display: "flex", gap: "6px" }}>
                                        <button className="btn btn-sm btn-primary" onClick={() => save(r)}>{t("calccat.save")}</button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => remove(r.id)}>{t("calccat.delete")}</button>
                                    </td>
                                )}
                            </tr>
                        ))}
                        {rows.length === 0 && <tr><td colSpan={isAdmin ? 5 : 4} style={{ opacity: 0.6 }}>{t("calccat.none")}</td></tr>}
                    </tbody>
                </table>
            </div>

            {isAdmin && (
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: "12px", padding: "16px", marginTop: "16px", maxWidth: "760px" }}>
                    <h3 style={{ fontSize: "14px", marginBottom: "12px" }}>{t("calccat.add")}</h3>
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "flex-end" }}>
                        <div><label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("calccat.code")}</label><input className="form-control" style={{ width: "90px" }} value={adding.code} onChange={(e) => setAdding((p) => ({ ...p, code: e.target.value }))} /></div>
                        <div><label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("calccat.label")}</label><input className="form-control" value={adding.label} onChange={(e) => setAdding((p) => ({ ...p, label: e.target.value }))} /></div>
                        <div><label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("calccat.landMarkup")}</label><input type="number" step="0.01" className="form-control" style={{ width: "110px" }} value={adding.land_markup} onChange={(e) => setAdding((p) => ({ ...p, land_markup: e.target.value }))} /></div>
                        <div><label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("calccat.containerMarkup")}</label><input type="number" step="0.01" className="form-control" style={{ width: "110px" }} value={adding.container_markup} onChange={(e) => setAdding((p) => ({ ...p, container_markup: e.target.value }))} /></div>
                        <button className="btn btn-primary" onClick={add}>{t("calccat.add")}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalculatorCategories;
